export default {
    path: '/',
    name: 'Portrait',
    component: resolve => require(['@/views/portrait'], resolve),
    redirect: '/portrait', 
    children: [
        {
            path: '/portrait',
            name: 'portrait',
            meta: [{
                path: '/portrait',
                title: '画像',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/portrait.vue'], resolve),
        },
    ],
}